import { useState } from "react";

import clsx from "clsx";

import heroBackground from "@assets/mmm/hero-bg.svg";
import { PrimaryButton } from "@shared/buttons";

import { MediaPlanTab } from "./media-plan/media-plan-tab";

export const LearnAboutMMM = () => {
  const [isCreatingMediaPlan, setIsCreatingMediaPlan] = useState(false);

  return isCreatingMediaPlan ? (
    <MediaPlanTab
      goBack={() => setIsCreatingMediaPlan(false)}
      goBackText="Back"
      autoOpenModal={true}
    />
  ) : (
    <div className=" h-full overflow-hidden">
      <div
        className={clsx(
          "bg-interstellar rounded-lg mx-6 mt-6  h-[calc(100%-56px)]  pt-12 pb-8 px-16 text-white",
          "flex items-start justify-around gap-8 bg-right-bottom bg-no-repeat",
        )}
        style={{ backgroundImage: `url(${heroBackground})` }}
      >
        <div className="flex flex-col">
          <div className="max-w-[800px]">
            <h1 className="text-[42px] leading-[56px] mb-7 mt-2">
              You&apos;re ready to create your first media plan!
            </h1>
            <PrimaryButton onClick={() => setIsCreatingMediaPlan(true)}>
              Get Started
            </PrimaryButton>
          </div>
        </div>
        <div>
          <Clip url="https://storage.googleapis.com/files.northbeam.io/img/231220_1701_northbeam_orb_v1.3%20(stretching%20and%20jumpiness%20fixed).webm" />
        </div>
      </div>
    </div>
  );
};

function Clip({ url }: { url: string }) {
  return (
    <video className="h-[calc(100%-200px)]" src={url} autoPlay loop muted>
      Sorry, your browser does not support embedded videos.
    </video>
  );
}
